<template>
  <Collapse
    v-if="histories.length"
    class="tenant-submission-comment-history"
    :expand="false"
    :withBorder="false"
  >
    <div
      slot="title"
      class="comment-title"
    >
      {{ $t('tenantProjects.sendHistory') }}
    </div>
    <table
      slot="content"
      class="history-table"
    >
      <thead>
        <tr>
          <th
            v-for="(header, index) in historyHeaders"
            :key="index"
            :class="header.class"
          >
            {{ header.title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(history, index) in histories"
          :key="index"
        >
          <td>{{ history.createdBy.displayName }}</td>
          <td>{{ history.emailReceivers.to.replace(/;/g, '; ') }}</td>
          <td>{{ history.emailReceivers.cc.replace(/;/g, '; ') }}</td>
          <td>{{ history.emailReceivers.bcc.replace(/;/g, '; ') }}</td>
          <td style="white-space: nowrap;">
            {{ history.actionType | customStatusLabel | capitalize }}
          </td>
          <td>{{ history.createdAt | formatDate('DD MMM YY HH:mm') }}</td>
        </tr>
      </tbody>
    </table>
  </Collapse>
</template>

<script>
import Collapse from '@/controls/Collapse'
import i18n from '@/utils/i18n'

export default {
  name: 'PostFitOutCommentHistory',
  components: {
    Collapse,
  },
  props: {
    histories: {
      type: Array,
      default: () => ([]),
    },
  },
  setup () {
    const historyHeaders = [{
      title: i18n.t('table.header.sender'),
    }, {
      title: i18n.t('table.header.to'),
    }, {
      title: i18n.t('table.header.cc'),
    }, {
      title: i18n.t('table.header.bcc'),
    }, {
      title: i18n.t('table.header.status'),
    }, {
      title: i18n.t('table.header.time'),
    }]
    return {
      historyHeaders,
    }
  },
}
</script>

<style lang="scss" scoped>
.tenant-submission-comment-history {
  ::v-deep .title-container {
    border-bottom: 1px solid #e0e0e0;
  }

  .comment-title {
    font-weight: bold;
  }
  .history-table {
    table-layout: fixed;
  }
}
</style>
